import { Button, Card, Input, Spinner, Typography } from '@material-tailwind/react'
import React, { useState, useEffect, useMemo, useRef } from 'react'
import { useForm, Controller } from 'react-hook-form';
import AInput from '../../components/fields/AInput';
import ASelect from '../../components/fields/ASelect';
import ASwitch from '../../components/fields/ASwitch';
import AIcon from '../../components/partials/AIcon';
import UploadPhoto from '../../components/upload/UploadPhoto';
import { useShared } from '../../hooks/useShared';
import { ToastContainer, toast } from 'react-toastify';

import ASpinner from '../../components/partials/ASpinner';
import ABreadcrumbs from '../../components/breadcrumbs/ABreadcrumbs';
import APDate from '../../components/fields/APDate';


const breadcrumbs = [{ name: 'شرکت', link: 'null' }];
const companyFields = [
    { label: 'نوع فعاليت', name: 'company_type', type: 'select', roles: [1], icon: 'text-outline', className: '', required: "نوع شرکت الزامی است", isStyle:false,isDisabled: true, options:[] },
    { label: 'اسم شرکت به دری', name: 'name_af', type: 'text', roles: [1], icon: 'text-outline', className: '', required: "نام شرکت الزامی است", isStyle:false,isDisabled: true  },
    { label: 'اسم شرکت به انگلسی', name: 'name_en', type: 'text', roles: [1], icon: 'text-outline', className: '', required: "نام شرکت الزامی است",isDisabled: true  },
    { label: 'شماره جواز', name: 'license_number', type: 'text', roles: [1], icon: 'star-outline', className: '', required: "شماره جواز شرکت الزامی است" ,isDisabled: true },
    { label: 'TIN شماره', name: 'tin_number', type: 'text', roles: [1], icon: 'star-outline', className: '', required: "شماره تین شرکت الزامی است"  ,isDisabled: true },
    { label: 'اردس شرکت به انگلسی', name: 'address', type: 'text', roles: [1], icon: 'location-outline', className: '', required: "ادرس شرکت الزامی است",isDisabled: true },
    { label: 'تليفون', name: 'phone', type: 'text', roles: [1], icon: 'call-outline', className: '', required: false ,isDisabled: true },
    { label: 'ايميل', name: 'email', type: 'email', roles: [1], icon: 'at-outline', className: '', required: false ,isDisabled: true },
    { label: 'سال تائسيس', name: 'establishment_date', type: 'text', roles: [1], icon: 'calendar-outline', className: '', required: false ,isDisabled: true, onlyYear: true, render: true  },
    { label: 'مالک', name: 'owner', type: 'select', roles: [1], icon: null, className: '', required: false, options: [] ,isDisabled: true, hide:true },
    { label: 'زون فعاليت', name: 'zone', type: 'select', roles: [1], icon: null, className: '', required: "زون فعاليت شرکت الزامی است", options: [],isDisabled: true, },
    { label: 'Rex. Number', name: 'rex_number', type: 'text', icon: 'text-outline', roles: [1], className: '', required: false,isDisabled: true,},
    { label: 'حالت', name: 'status', type: 'switch', roles: [1], icon: 'book-outline', className: '', required: false ,isDisabled: true,hide:true },
    { label: 'ملاحظات', name: 'description', type: 'textarea', roles: [1], icon: 'book-outline', className: '', required: false ,isDisabled: true },
    { label: 'لوګو', name: 'logo', type: 'logo', roles: [1], icon: 'book-outline', className: '' ,isDisabled: true },

];


export default function Company() {
    const { auth: { user }, http, uploadPhoto, setPhoto,model, setModel, consts } = useShared()
    const { register, handleSubmit, control, formState: { errors }, reset, setValue } = useForm({});
    const [fields, setFields] = useState([...companyFields])
    const [errorMessage, setErrorMessage] = useState(null)
    const [loading, setLoading] = useState({ info: false, submit: false })
   // const [company, setCompany] = useState(null)
    const [editInfo, setEditInfo] = useState(false)



    useEffect(() => {
        setLoading(pre => ({ ...pre, info: true }))
        const uId = user?.user?.id;
        http.get(`/api/getCompanyByUserId/${uId}`).then(res => {
            console.log("getCompanyByUserId", res);
            setModel(null)
            if (res.data.success) {
                reset(res.data?.data)
                setModel(res.data?.data)
                console.log("company ", res.data.data);
                if (res.data.data) {
                    const img = res.data?.data?.image_data?.path
                    setPhoto({ url: img ? consts.BASE_URL + img : '', photo: null })
                }
            }
            setLoading(pre => ({ ...pre, info: false }))
        }, error => {
            setLoading(pre => ({ ...pre, info: false }))

            console.log('Error error');
        })
        getCompanyTypes();
        getZones()
    }, [])


    const getCompanyTypes = (id) => {
        setLoading(true)
        http.post(`/api/categoryAdvanceSearch?typeId=${52}`).then(res => { //get company types
            console.log(id, 'get getCompanyTypes ', res);
            if (res.data.success) {
                setLoading(pre => ({ ...pre, show: false }))
                companyFields[0].options = res.data?.data
                setFields(companyFields)
                setLoading(false)
            }
        }, err => {
            setLoading(false)
            console.log('getCompanyTypes error ', err);
        })
        
    }

    const getZones = ( ) => {
        console.log("getZones");
        setLoading(true)
         http.post('api/zonesAdvanceSearch', { nameId: true }).then(res => {
            console.log("czonesAdvanceSearch", res);
            if (res.data.success) {
               
                const data = res?.data?.data;
                companyFields[10].options  = data
                setFields(companyFields)
                setLoading(false)
            }
        }, err => {
            setLoading(false)
            console.log('getZones  error ', err);
        })


    }



    const submit = async (data) => {
        console.log(data);
        setErrorMessage(null)

        console.log('submit ', data);
        try {

            setLoading(pre => ({ ...pre, sumbit: true }))
            const uId = user?.user?.id;
            data['owner'] = { value: uId, label: user?.user?.full_name }
            const res = await http.post('api/companies', data);
            console.log('company ', res);
            if (res.data?.success) {
                uploadPhoto(model?.attachment ).then(res => {
                    console.log("uploadPhoto " , res)
                   // setPhoto(null)
                 
                });
                toast.success(res.data.message);
            }


            setLoading(pre => ({ ...pre, sumbit: false }))

        } catch (error) {
            console.log("error", error);
            setLoading(pre => ({ ...pre, sumbit: false }))
            const err = error?.response?.data
            if (!err?.success) {
                setErrorMessage(err?.message)
                toast.error(err?.message);
            }
        }

    }


    const handleEnableInputFields = () => {
        setEditInfo(pre => {
            if(pre){
                fields.map(f => {
                    f.isDisabled = true
                })
            }
            else{
                fields.map(f => {
                    f.isDisabled = false
                })
            }
            return !pre
        })
        console.log(editInfo)
     
        setErrorMessage(null)
    }



    return (
        <div className='relative'>
            <ABreadcrumbs links={breadcrumbs} />
            <div className='md:flex  items-start gap-4'>

                <Card className="w-full md:w-[70%]  p-2 md:p-4 mt-4 relative">
                    <div className='flex justify-between border-b pb-2'>
                        <p className="text-sm text-main-color font-bold ">شرکت</p>
                        <Button onClick={handleEnableInputFields} color="amber" className='py-1 px-2 rounded-full drop-shadow-lg'> <AIcon name="create-outline" size={20} /> </Button>
                    </div>

                    <form className=" flex flex-col gap-4 mt-4" onSubmit={handleSubmit(submit)}>


                        <div className='grid md:grid-cols-1 gap-4'>
                            {
                                fields?.map((data, i) => {
                                    return (
                                        <div key={i}>
                                            {
                                                data?.type === 'text' || data.type === 'date' || data?.type === 'textarea' || data?.type === 'password' || data?.type === 'email' ?
                                                    <AInput v={{ register, errors, data }} />

                                                    : data?.type === 'select' ? <ASelect v={{ register, errors, control, data }}  />
                                                               
                                                                    : data.type === 'pdate'  ? <APDate v={{ register, errors,setValue, control, data }} />
                                                                        : null
                                            }
                                        </div>
                                    )
                                })
                            }
                            {/*    <UploadPhoto v={{ obj: null, className: "md:hidden " }} /> */}
                        </div>

                        {errorMessage && <Typography
                            variant="small"
                            color="gray"
                            className="flex items-center text-red-500 gap-2 font-normal "
                        >
                            <AIcon name="alert-circle-outline" className="-mt-0.5 h-4 w-4" />
                            {errorMessage}
                        </Typography>}
                        <div className='flex gap-4 md:justify-end'>
                            <Button className="btn1 w-full md:w-[20%]" size='sm' type="submit" disabled={loading.submit || !editInfo}>
                                {loading.submit ? <Spinner color="teal" className="h-4 w-4" /> : "Update"}
                            </Button>

                        </div>


                    </form>
                </Card>

                <div className='w-full  md:w-[30%] '>
               {/*      <UploadPhoto v={{ obj: company?.image_data, className: "pt-4 relative", showSumitButton: true, member:company, title:'Upload Company Logo' }} /> */}
                    <UploadPhoto v={{ obj: model?.image_data, modelName:'Company', title: 'Upload Company Logo', className: "pt-4 relative",showSumitButton: true, }} />
                </div>

            </div>
            {loading.info && <ASpinner />}
            <ToastContainer />
        </div>
    )
}
